package meineglasfaser.frontend.admin.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.rememberPageContext
import io.ktor.client.call.*
import kotlinx.coroutines.flow.MutableStateFlow
import meineglasfaser.api.AdminUserPrincipal
import meineglasfaser.api.routes.AdminRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.withAuth

sealed interface AdminUserState {
    data object Indeterminate : AdminUserState

    data class LoggedIn(val baseInfo: AdminUserPrincipal) : AdminUserState

    data object LoggedOut : AdminUserState

    fun baseInfoOrNull(): AdminUserPrincipal? {
        return when (this) {
            is LoggedIn -> baseInfo
            else -> null
        }
    }
}

val GlobalAdminUserState = MutableStateFlow<AdminUserState>(AdminUserState.Indeterminate)

val LocalAdminUserState = compositionLocalOf<AdminUserState> { AdminUserState.Indeterminate }

@Composable
fun ProvideAdminUserState(content: @Composable () -> Unit) {
    val state by GlobalAdminUserState.collectAsState()

    LaunchedEffect(state) {
        if (state != AdminUserState.Indeterminate) return@LaunchedEffect
        BackendApi.get(AdminRoutes.Account.BaseInfo()) {
            withAuth()
        }.fold(
            onSuccess = { response ->
                GlobalAdminUserState.value = AdminUserState.LoggedIn(
                    response.body<AdminUserPrincipal>()
                )
            },
            onFailure = { error ->
                console.error("Fehler beim Laden des Benutzerstatus:", error.message)
                GlobalAdminUserState.value = AdminUserState.LoggedOut
            }
        )
    }

    CompositionLocalProvider(LocalAdminUserState provides state) {
        content()
    }
}

@Composable
fun AdminUserStateRedirectIfLoggedIn() {
    val ctx = rememberPageContext()
    val state = LocalAdminUserState.current

    LaunchedEffect(state) {
        if (state is AdminUserState.LoggedIn) {
            ctx.router.navigateTo("/")
            Toasts.display(
                Toast.info(
                    title = "Bereits angemeldet",
                    message = "Willkommen!",
                )
            )
        }
    }
}

@Composable
fun AdminUserStateRedirectIfLoggedOut() {
    val ctx = rememberPageContext()
    val state = LocalAdminUserState.current

    LaunchedEffect(state) {
        if (state is AdminUserState.LoggedOut) {
            ctx.router.navigateTo("/auth/login")
            Toasts.display(
                Toast.info(
                    title = "Anmeldung erforderlich",
                    message = "Admin-Panel kann nur nach Anmeldung benutzt werden",
                )
            )
        }
    }
}
